import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CodaltComponent } from 'src/app/codalt.component';
import { QuestionsService } from 'src/app/services/questions.service';

@Component({
    selector: 'app-toolbox-question-form',
    templateUrl: './toolbox-question-form.component.html',
    styleUrls: ['./toolbox-question-form.component.scss'],
    standalone: false,
})
export class ToolboxQuestionFormComponent extends CodaltComponent implements OnInit {
    @ViewChildren('choiceInput') choiceInputs!: QueryList<ElementRef>;
    @ViewChildren('questionInput') questionInputs!: QueryList<ElementRef>;

    @Input() toolboxId: number;

    form: FormGroup;

    get questions() {
        return this.form.get('questions') as FormArray;
    }

    constructor(
        private questionService: QuestionsService,
        private fb: FormBuilder
    ) {
        super();
        this.form = this.fb.group({
            questions: this.fb.array([]),
        });
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.questionService.getQuestions(this.toolboxId).subscribe(questions => {
                this.setQuestions(questions);
            })
        );
    }

    setQuestions(questionsData: any[]) {
        const questionFormGroups = questionsData.map(q =>
            this.fb.group({
                id: [q.id],
                question: [q.question, Validators.required],
                choices: this.fb.array(
                    q.choices.map((c: any) =>
                        this.fb.group({
                            id: [c.id],
                            text: [c.text, Validators.required],
                            is_correct: [c.is_correct],
                        })
                    )
                ),
            })
        );
        const questionsFormArray = this.fb.array(questionFormGroups);
        this.form.setControl('questions', questionsFormArray);
    }

    addQuestion() {
        const question = this.fb.group({
            id: [null],
            question: ['', Validators.required],
            choices: this.fb.array([this.fb.group({ text: ['', Validators.required], is_correct: false })]),
        });
        this.questions.push(question);

        setTimeout(() => {
            const inputs = this.questionInputs.toArray();
            if (inputs.length) {
                inputs[inputs.length - 1].nativeElement.focus();
            }
        });
    }

    removeQuestion(index: number) {
        const questionId = this.questions.at(index).get('id').value;
        this.questions.removeAt(index);

        this.subscriptions.add(this.questionService.deleteQuestion(questionId).subscribe());
    }

    choices(question: FormGroup) {
        return question.get('choices') as FormArray;
    }

    getFormGroup(control: any): FormGroup {
        return control as FormGroup;
    }

    addChoice(question: FormGroup) {
        this.choices(question).push(this.fb.group({ text: ['', Validators.required], is_correct: false }));

        setTimeout(() => {
            const inputs = this.choiceInputs.toArray();
            if (inputs.length) {
                inputs[inputs.length - 1].nativeElement.focus();
            }
        });
    }

    removeChoice(question: FormGroup, index: number) {
        const choiceId = this.choices(question).at(index).get('id')?.value;
        this.choices(question).removeAt(index);

        if (choiceId) {
            this.subscriptions.add(this.questionService.deleteChoice(choiceId).subscribe());
        }
    }

    submit() {
        if (this.form.valid) {
            this.questionService.saveQuestion(this.toolboxId, this.form.value).subscribe();
        }
    }
}
